import ts from 'typescript';
import { Helper } from '../Helper';
export class UpgradeHelper extends Helper {
    constructor({ approveUpgrade }) {
        super();
        this.approveUpgrade = approveUpgrade;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        const decl = this.approveUpgrade;
        if (ts.isPropertyDeclaration(decl)) {
            sb.context.reportUnsupported(decl);
            return;
        }
        sb.emitHelper(decl, options, sb.helpers.invokeSmartContractMethod({ method: decl }));
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitHelper(node, options, sb.helpers.unwrapBoolean);
            },
            whenTrue: () => {
                sb.emitPushInt(node, 1);
                sb.emitHelper(node, options, sb.helpers.getArgument);
                sb.emitOp(node, 'UNPACK');
                sb.emitOp(node, 'DROP');
                sb.emitSysCall(node, 'Neo.Contract.Migrate');
                sb.emitOp(node, 'DROP');
                sb.emitPushBoolean(node, true);
            },
            whenFalse: () => {
                sb.emitPushBoolean(node, false);
            },
        }));
    }
}

//# sourceMappingURL=UpgradeHelper.js.map
